import React from 'react';
import ActivityCard from './ActivityCard';
import type { CustomerActivityItem } from '@/api/services/customerActivity';
import { EmptyState } from '@/components/ui';
import { tActivity } from '@/i18n/activity';
import type { ActivityActionCapabilities } from '@/utils/activityActions';

type Props = {
  items: CustomerActivityItem[];
  loading?: boolean;
  onMarkRead?: (id: string) => void;
  emptyTitle?: string;
  emptyDescription?: string;
  actionCapabilities?: ActivityActionCapabilities;
};

export default function ActivityTimeline({
  items,
  loading,
  onMarkRead,
  emptyTitle,
  emptyDescription,
  actionCapabilities,
}: Props) {
  if (loading && items.length === 0) {
    return <p className="muted">Loading activity…</p>;
  }
  if (items.length === 0) {
    return (
      <EmptyState
        title={emptyTitle || tActivity('activity.empty.title')}
        description={emptyDescription || tActivity('activity.empty.description')}
      />
    );
  }
  return (
    <div className="activity-timeline">
      {items.map((item) => (
        <ActivityCard
          key={item.id}
          item={item}
          onMarkRead={onMarkRead}
          compact
          actions={actionCapabilities}
        />
      ))}
    </div>
  );
}
